import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=ef793fb2&scoped=true&"
import script from "./signup.vue?vue&type=script&lang=js&"
export * from "./signup.vue?vue&type=script&lang=js&"
import style0 from "./signup.vue?vue&type=style&index=0&id=ef793fb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef793fb2",
  null
  
)

export default component.exports